import React, { useRef, useState } from 'react'
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { availableLanguages } from '../../components/data/languageData';
import CustomCheckboxDropdown from '../../components/forms/checkBoxDropDown';
import successToast from '../../components/toasts/successToast';
import { domainName } from '../../components/data/domainName';
import { useDispatch } from 'react-redux';
import { addGlossaryAction, uploadGlossaryFile } from '../../redux/actions/resourceAction';
import errorToast from '../../components/toasts/errorToast';
import { Button, Spinner } from 'react-bootstrap';
import { IoArrowBack } from 'react-icons/io5';

export const AddResource = () => {
    const navigate = useNavigate();
    const [selectedFileName, setSelectedFileName] = useState('');
    const [selectedFileUrl, setSelectedFileUrl] = useState('');
    const [selectedInputUri, setSelectedInputUri] = useState('');
    const [loading, setLoading] = useState(false);
    const [uploadLoading, setUploadLoading] = useState(false)
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);
    const dispatch = useDispatch();

    const initialValues = {
        name: '',
        domain: "",
        file: null,
        languages: [],
        source_name: "",
        file_type: "",
        source_lang: "",
        target_lang: ""
    };

    // const validationSchema = Yup.object().shape({
    //     name: Yup.string().required('Required'),
    //     domain: Yup.string().required('Required'),
    //     file: Yup.string().required('Required'),
    //     // languages: Yup.array().min(1, 'At least one language is required'),
    //     source_name: Yup.string().required('Required'),
    // });

    const validationSchema = Yup.object().shape({
        name: Yup.string().required('Required'),
        domain: Yup.string().required('Required'),
        file: Yup.string().required('Required'),
        source_name: Yup.string().required('Required'),
        file_type: Yup.string().required('Required'),

        languages: Yup.array().when('file_type', {
            is: 'csv',
            then: (schema) => schema.min(2, 'At least a pair of language is required'),
            otherwise: (schema) => schema.notRequired(),
        }),

        source_lang: Yup.string().when('file_type', {
            is: (fileType) => fileType !== 'csv',
            then: (schema) => schema.required('Source language is required'),
            otherwise: (schema) => schema.notRequired(),
        }),

        target_lang: Yup.string().when('file_type', {
            is: (fileType) => fileType !== 'csv',
            then: (schema) => schema.required('Target language is required'),
            otherwise: (schema) => schema.notRequired(),
        }),
    });

    const handleFileChange = (event, setFieldValue) => {
        setUploadLoading(true)
        const file = event.target.files[0];
        console.log(file, file.type);
        if (file.type === "text/csv") {
            setFieldValue('file_type', "csv");
        } else {
            setFieldValue('file_type', "tmx");
        }
        dispatch(uploadGlossaryFile(file, onUploadSuccess, onError));
        if (file) {
            setFieldValue('file', file);
        }
    };

    const onUploadSuccess = (data) => {
        setSelectedFileUrl(data.data.data.filePathUrl);
        setSelectedInputUri(data.data.data.gsUri);
        setSelectedFileName(data.data.data.originalName);
        setUploadLoading(false)
        successToast(data.data.message);
    };

    const onSubmit = (values) => {
        setLoading(true);
        dispatch(addGlossaryAction({
            "name": values.name,
            "file_url": selectedFileUrl,
            "inputUri": selectedInputUri,
            "languageCodes": values.languages,
            "domain": values.domain,
            "source_name": values.source_name,
            "file_type": values.file_type,
            "source_lang": values.source_lang,
            "target_lang": values.target_lang
        }, onSuccess, onError));
    };
    const onError = (data) => {
        setLoading(false);
        setUploadLoading(false)
        errorToast(data?.data?.message);
    };

    const onSuccess = (data) => {
        setLoading(false);
        successToast(data?.data?.message);
        navigate('/resources');
    };

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setDropdownOpen(false);
        }
    };

    const handleDownloadDemo = (demoFileUrl) => {
        const link = document.createElement('a');
        link.href = demoFileUrl;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <div className="d-flex  vh-100" onClick={handleClickOutside}>
            <div className="w-100  ">
                <div className="w-100 d-flex align-items-center header border-bottom position-sticky top-0 bg-white py-2">
                    <span className="px-1 fs_16 cursor_pointer pb-1" onClick={() => navigate(-1)}><IoArrowBack /></span>
                    <h2 className="fs_20 fw_400 fn_Roboto text-start px-3 pt-1">
                        Add Resources
                    </h2>
                </div>
                <div className="flex-grow-1 pt-3">
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={onSubmit}
                    >
                        {({ values, setFieldValue, isValid, dirty }) => (
                            <Form className="d-flex flex-column h-100 justify-content-between">
                                <div>
                                    <div className="text-start gap-3 mb-2 text-nowrap mx-4">
                                        <label htmlFor="name" className="py-1">Glossary Name</label>
                                        <div className="d-flex position-relative">
                                            <Field
                                                type="text"
                                                placeholder="Enter Glossary Name"
                                                id="name"
                                                name="name"
                                                className="input-field"
                                                style={{ width: '20rem' }}
                                            />
                                        </div>
                                        <ErrorMessage name="name" component="div" className="text-danger mt-1 fs_12" />
                                    </div>
                                    <div className="text-start gap-3 mb-2 text-nowrap mx-4">
                                        <label htmlFor="source_name" className="py-1">Source Name</label>
                                        <div className="d-flex position-relative">
                                            <Field
                                                type="text"
                                                placeholder="Enter Source Name"
                                                id="source_name"
                                                name="source_name"
                                                className="input-field"
                                                style={{ width: '20rem' }}
                                            />
                                        </div>
                                        <ErrorMessage name="source_name" component="div" className="text-danger mt-1 fs_12" />
                                    </div>
                                    <div className="text-start gap-3 mb-2 text-nowrap mx-4">
                                        <label htmlFor="domain" className="py-1">
                                            Select Domain
                                        </label>
                                        <div className="d-flex position-relative">
                                            <Field
                                                as="select"
                                                id="domain"
                                                name="domain"
                                                value={values.domain}
                                                className="input-field"
                                                style={{ width: "20rem" }}
                                            >
                                                <option value="">Select Domain</option>
                                                {domainName.map((domain) => (
                                                    <option key={domain.value} value={domain.value}>
                                                        {domain.label}
                                                    </option>
                                                ))}
                                            </Field>
                                        </div>
                                        <ErrorMessage
                                            name="domain"
                                            component="div"
                                            className="text-danger mt-1 fs_12"
                                        />
                                    </div>

                                    <div className="text-start gap-3 mb-2 text-nowrap mx-4">
                                        <label htmlFor="file" className="py-1">Select destination for uploaded file</label>
                                        <div className="mb-2 text-muted fs_12">
                                            Supported file formats:
                                            <a
                                                onClick={() => handleDownloadDemo("https://storage.googleapis.com/rare-shadow-276706.appspot.com/Glossary%20Demo%20CSV%20%20-%20Sheet1.csv")}
                                                href="#"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="ms-1"
                                            ><strong>.csv</strong></a> and
                                            <a
                                                onClick={() => handleDownloadDemo("https://storage.googleapis.com/rare-shadow-276706.appspot.com/demo-tmx-file.tmx")}
                                                href="#"
                                                target="_blank"
                                                rel="noopener noreferrer cursor_pointer"
                                                className="ms-1 me-1"
                                            >
                                                <strong>.tmx</strong>.
                                            </a>
                                            Language codes used in file headers must match Google’s language code format.
                                            <a
                                                href="https://cloud.google.com/translate/docs/languages"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="ms-1"
                                            >
                                                Learn More
                                            </a>
                                        </div>
                                        <div className="d-flex position-relative">
                                            <div className="d-flex align-items-center" style={{ border: '1px solid #ced4da', borderRadius: '0.25rem', width: '20rem', backgroundColor: 'white' }}>
                                                <label
                                                    htmlFor="fileInput"
                                                    className="btn btn-light mb-0"
                                                    style={{
                                                        backgroundColor: '#FDF6F6',
                                                        padding: '0.5rem 1rem',
                                                        cursor: 'pointer',
                                                    }}
                                                >
                                                    {uploadLoading ? <Spinner size="sm" className="px-1" /> : ""}
                                                    {uploadLoading ? "Uploading..." : "Select File"}
                                                </label>
                                                <input
                                                    id="fileInput"
                                                    name="file"
                                                    type="file"
                                                    accept=".csv, .tmx"
                                                    onChange={(event) => handleFileChange(event, setFieldValue)}
                                                    style={{ display: 'none' }}
                                                />
                                                <Field
                                                    type="text"
                                                    placeholder="No File Selected"
                                                    id="file"
                                                    name="file"
                                                    value={selectedFileName}
                                                    className="input-field border-0 ms-2"
                                                    style={{
                                                        width: '100%',
                                                        backgroundColor: 'white',
                                                        padding: '0.375rem 0',
                                                    }}
                                                    readOnly
                                                />
                                            </div>
                                        </div>
                                        <ErrorMessage name="file" component="div" className="text-danger mt-1 fs_12" />
                                    </div>


                                    {values.file_type === "csv" && selectedInputUri &&
                                        <div className="text-start gap-3 mb-2 text-nowrap mx-4" ref={dropdownRef}>
                                            <label htmlFor="languages" className="py-1">Select Languages</label>
                                            <CustomCheckboxDropdown
                                                options={availableLanguages}
                                                name="languages"
                                                value={values.languages}
                                                onChange={setFieldValue}
                                                placeholder={'Select Languages'}
                                                dropdownOpen={dropdownOpen}
                                                setDropdownOpen={setDropdownOpen}
                                            />
                                            <ErrorMessage name="languages" component="div" className="text-danger mt-1 fs_12" />
                                        </div>
                                    }

                                    {values.file_type === "tmx" && selectedInputUri &&
                                        <>
                                            <div className="text-start gap-3 mb-2 text-nowrap mx-4">
                                                <label htmlFor="source_lang" className="py-1">
                                                    Select Source Language
                                                </label>
                                                <div className="d-flex position-relative">
                                                    <Field
                                                        as="select"
                                                        id="source_lang"
                                                        name="source_lang"
                                                        value={values.source_lang}
                                                        className="input-field"
                                                        style={{ width: "20rem" }}
                                                    >
                                                        <option value="">Select language</option>
                                                        {availableLanguages.map((lang) => (
                                                            <option key={lang.value} value={lang.value}>
                                                                {lang.label}
                                                            </option>
                                                        ))}
                                                    </Field>
                                                </div>
                                                <ErrorMessage
                                                    name="source_lang"
                                                    component="div"
                                                    className="text-danger mt-1 fs_12"
                                                />
                                            </div>

                                            <div className="text-start gap-3 mb-2 text-nowrap mx-4">
                                                <label htmlFor="target_lang" className="py-1">
                                                    Select Target Language
                                                </label>
                                                <div className="d-flex position-relative">
                                                    <Field
                                                        as="select"
                                                        id="target_lang"
                                                        name="target_lang"
                                                        value={values.target_lang}
                                                        className="input-field"
                                                        style={{ width: "20rem" }}
                                                    >
                                                        <option value="">Select language</option>
                                                        {availableLanguages.map((lang) => (
                                                            <option key={lang.value} value={lang.value}>
                                                                {lang.label}
                                                            </option>
                                                        ))}
                                                    </Field>
                                                </div>
                                                <ErrorMessage
                                                    name="source_lang"
                                                    component="div"
                                                    className="text-danger mt-1 fs_12"
                                                />
                                            </div>
                                        </>
                                    }
                                </div>
                                <div className="d-flex gap-4 mx-4 mt-4 mb-2">
                                    <Button
                                        disabled={loading}
                                        variant='primary'
                                        type="submit"
                                        className='d-flex text-nowrap'
                                        style={{ minWidth: '80px' }}
                                    >
                                        <div className='fs_12 d-flex gap-2 justify-content-center'>
                                            {loading ? <Spinner size="sm" className="mt-1" /> : ""}
                                            <label className="fs_16">{!loading ? 'Create' : 'Creating'}</label>
                                        </div>
                                    </Button>
                                    <button type="button" className="btn btn-secondary" style={{ width: '5rem' }} onClick={() => navigate('/resources')}>Cancel</button>
                                </div>
                            </Form>
                        )}
                    </Formik>

                </div>
            </div>
        </div >
    )
}
